import React from 'react';
import Loader from '../Loader/Loader';
var css = {
  "fullPageLoader": "rui-CFakO",
  "loader": "rui-xzSuV"
};
import classNames from 'classnames';
var FullPageLoader = function FullPageLoader(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'fixed' : _ref$position,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.fullPageLoader, className),
    style: {
      position: position
    },
    "data-aut-id": "fullPageLoader"
  }, /*#__PURE__*/React.createElement("div", {
    className: css.loader
  }, /*#__PURE__*/React.createElement(Loader, {
    stroke: "2px"
  }), text && /*#__PURE__*/React.createElement("p", null, text)));
};
export default FullPageLoader;